import { HttpModelConverter } from '../../../../../../core/converter/httpModel.converter';
import { Injectable } from '@angular/core';
import { WorkflowTaskDefinitionModel } from '../workflowTaskDefinition.model';

@Injectable({
    providedIn: 'root'
})
export class WorkflowTaskDefinitionConverter extends HttpModelConverter<WorkflowTaskDefinitionModel> {

    protected createInstance(): WorkflowTaskDefinitionModel {
        return new WorkflowTaskDefinitionModel();
    }

    protected enrichObject(result: WorkflowTaskDefinitionModel, src: WorkflowTaskDefinitionModel) {
    }
}
